// Typelizer digest 21d4c4d942f73bc565b05415d298188c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** POST /account/sign_in_link */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/account/sign_in_link', {}, options),
    method: 'post',
  }),

  /** GET /account/sign_in_code */
  code: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/account/sign_in_code', {}, options),
    method: 'get',
  }),

  /** POST /account/sign_in_code */
  verify: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/account/sign_in_code', {}, options),
    method: 'post',
  }),

  /** GET /account/sign_in_link/:token */
  show: (
    params: { token: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/account/sign_in_link/:token', params, options),
    method: 'get',
  }),

  /** POST /account/sign_in_link/:token */
  redeem: (
    params: { token: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/account/sign_in_link/:token', params, options),
    method: 'post',
  }),
}
